/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	export class TrackPoint {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(json:object, pointIndex:number, duration:number, length:number) {
			this.pointIndex = pointIndex;

			this.dateTime = json['pass_at'] * 1000;

			const point = json['point'];
			const coordinate = point['coord'];
			this.position = new LatLng(coordinate[1], coordinate[0]);
			this.elevation = point['corrected_altitude'];

			this.distance = json['distance'];
			this.distanceRatio = this.distance / length;

			this.elapsedTime = json['elapse'] * 1000;
			this.elapsedTimeRatio = this.elapsedTime / duration;

			this.speed = 0;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getPointIndex():number {
			return this.pointIndex;
		}

		public getDateTime():number {
			return this.dateTime;
		}

		public getPosition():LatLng {
			return this.position;
		}

		public getElevation():number {
			return this.elevation;
		}

		public getElapsedTime():number {
			return this.elapsedTime;
		}

		public getElapsedTimeRatio():number {
			return this.elapsedTimeRatio;
		}

		public getDistance():number {
			return this.distance;
		}

		public getDistanceRatio():number {
			return this.distanceRatio;
		}

		public getSpeed():number {
			return this.speed;
		}

		public _setSpeed(speed:number):void {
			this.speed = speed;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private pointIndex:number;

		private position:LatLng;
		private elevation:number;

		private dateTime:number;

		private elapsedTime:number;
		private elapsedTimeRatio:number;

		private distance:number;
		private distanceRatio:number;

		private speed:number;
	}
}
